import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createFidelityAccountSchema = z.object({
  userId: z.string().min(1),
  balance: z.number().optional(),
});

export class CreateFidelityAccountDto extends createZodDto(createFidelityAccountSchema) {}
